export default "__VITE_ASSET__Co2GdcjE__"